import {Component, ComponentFactoryResolver, ComponentRef, ViewChild} from "@angular/core";
import {DxBaseModalComponent} from "../dx-base-modal.component";
import {SuiModal} from "ng2-semantic-ui";
import {DxModalResult} from "../../../domain/dx-modal-result";
import {DxModalContext} from "../../../domain/dx-modal-context";
import {DxModalContentHostDirective} from "../../directives/dx-modal-content-host.directive";
import {DxModalDisplayable} from "../../../domain/dx-modal-displayable";
import {DxAppError} from "../../../../dx-core/domain/error/dx-app-error";
import {DxModalResultType} from "../../../domain/dx-modal-result-type";
import {Subscription} from "rxjs";


@Component({
  selector: 'dx-edit-modal',
  templateUrl: './dx-edit-modal.component.html',
  styleUrls: ['./dx-edit-modal.component.css']
})
export class DxEditModalComponent extends DxBaseModalComponent {

  /** Ссылка на контейнер, хотящий динамический комопнет. */
  @ViewChild(DxModalContentHostDirective, {static: true})
  public contentHost: DxModalContentHostDirective;

  /** Ссылка на комонент, открытый в контенте. */
  protected _componentRef: ComponentRef<any>;
  /** Для корректной отписки от события `dirty`. */
  protected _subscription: Subscription;

  constructor(protected _modal: SuiModal<DxModalContext, DxModalResult, DxModalResult>,
              protected resolver: ComponentFactoryResolver) {
    super(_modal);
  }


  protected _init(): void {
    super._init();
    this._initContent();
    const saveBtn = this._buttons.find(btn => btn.resultType === DxModalResultType.SAVE);
    if(saveBtn) saveBtn.disabled = true;
  }


  protected _destroy(): void {
    super._destroy();
    // ВНИМАНИЕ!!! Порядок операций именно такой!
    if(this._subscription) this._subscription.unsubscribe();
    this._componentRef.destroy();
  }


  private _initContent(): void {
    this.contentHost.viewRef.clear();
    let factory = this._modal.context.componentFactory;
    if(!factory) {
      const clazz = this._modal.context.contentComponent;
      factory = this.resolver.resolveComponentFactory(clazz);
    }
    this._componentRef = this.contentHost.viewRef.createComponent(factory);
    const component = (<DxModalDisplayable> this._componentRef.instance);
    component.setInputs(this._modal.context.inputs);

    const saveBtn = this._buttons.find(btn => btn.resultType === DxModalResultType.SAVE);
    if(saveBtn) {
      const dirtyNotifier = component.getDirtyNotifier();
      if(!dirtyNotifier) {
        let msg = 'Для модального окна определена кнопка c операцией SAVE. ';
        msg += 'В этом случае комопнент, открываемый в модальном окне должен в обязательном порядке предоставить ';
        msg += 'эммиттер события редактирования данных компонента.';
        throw new DxAppError(msg);
      } else {
        this._subscription = dirtyNotifier.subscribe(dirty => {
          if (dirty.data && dirty.data['disableSave']) {
            saveBtn.disabled = true;
          } else {
            saveBtn.disabled = false;
          }
          this._buttons = [...this._buttons];
        });
      }
    }
  }


  protected _handleSaveBtnClick(): void {
    const component = (<DxModalDisplayable> this._componentRef.instance);
    this._modal.approve(new DxModalResult(DxModalResultType.SAVE, component.getEditResult()));
  }
}
